const frequencyList = [
  { id: 15, name: '15 minutes' },
  { id: 30, name: '30 minutes' },
  { id: 60, name: '1 hour' },
];
export const tripHeader = [
  {
    head: 'Trip Id',
    label: 'trip_id',
    selected: true,
    class: 'wp10',
  },
  {
    head: 'Status',
    label: 'status',
    selected: true,
    class: 'wp12',
  },
  {
    head: 'Source - Destination',
    label: 'route',
    truncateOn: 20,
    selected: false,
    class: 'wp15',
  },
  {
    head: 'Vehicle #',
    label: 'truck_number',
    selected: true,
    class: 'wp15',
  },
  {
    head: 'Driver #',
    label: 'driver_number',
    selected: true,
    class: 'wp10',
  },
  {
    head: 'Ping Freq Mins',
    label: 'ping_frequency_minutes',
    selected: true,
    class: 'wp12',
  },
  {
    head: 'Created On',
    label: 'createdAt',
    selected: true,
    class: 'wp10',
  }];

export const statusList = [
  { id: null, name: 'ALL STATUS' },
  { id: 'PENDING', name: 'PENDING', color: 'color-cocoabrown' },
  { id: 'STARTED', name: 'STARTED', color: 'color-blackcurrant' },
  { id: 'COMPLETED', name: 'COMPLETED', color: 'color-myrtle' },
];

export const tripTypes = [
  { id: 0, name: 'ALL TRIPS' },
  { id: 1, name: 'HALTED TRIPS', value: true },
];

export const filters = {
  STATUS: 'Status',
  CITY: 'City',
  TRIPS: 'Trips',
};
export default frequencyList;

export const autoCompleteList = [
  { id: 24, name: '24 hours' },
  { id: 48, name: '48 hours' },
  { id: 72, name: '72 hours' },
];

export const trackButtons = [{
  id: 1,
  name: 'Add',
  emitMethod: 'showTripForm',
  show: true,
  class: 'header_pbtn',
  disabled: false,
  permission: 'update_tracking',
}];

export const searchParameters = [
  {
    id: 1,
    name: 'source',
    query: 'source',
  },
  {
    id: 2,
    name: 'destination',
    query: 'destination',
  },
  {
    id: 3,
    name: 'truck number',
    query: 'truck_number',
  },
  {
    id: 4,
    name: 'reference id',
    query: 'customer_reference',
  },
];

export const Menu = [{
  id: 'Track',
  name: 'Track',
}];

